import { render, staticRenderFns } from "./ShangWu1.vue?vue&type=template&id=704775c2&scoped=true&"
import script from "./ShangWu1.vue?vue&type=script&lang=js&"
export * from "./ShangWu1.vue?vue&type=script&lang=js&"
import style0 from "./ShangWu1.vue?vue&type=style&index=0&id=704775c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704775c2",
  null
  
)

export default component.exports